/* eslint-disable func-names */
import { setCartItemsCount } from './appState/ducks/general';

const reduxManagedPlaceholders = {
  '#cart': {
    dispatcher: setCartItemsCount
  }
};

(function($) {
  window.DR = window.DR || {};

  window.DR.ajaxload = function(arr) {
    function loadBlock(o) {
      $.ajax({
        url: o.url,
        method: o.type,
        type: 'json',
        success: function(resp) { if (o.place) $(o.place).html(resp.content); }
      });
    }
    if (arr) {
      for (let i = 0; i < arr.length; i++) {
        loadBlock(arr[i]);
      }
    }
  };

  window.DR.ajaxLoad = function ajaxLoad(arr) {
    function loadBlock(o) {
      const method = (o.type) ? o.type : 'POST';

      $.ajax({
        url: o.url,
        method: method,
        type: 'json',
        success: function(resp) {
          if (resp.status === 'OK') {
            $(resp.results).each(function() {
              const res = $(this)[0];
              if (res.response.result === 'OK') {
                // Redux managed value - don't replace DOM, but dispatch to store
                if (reduxManagedPlaceholders[res.placeholder]) {
                  const val = parseInt($(res.response.content).html(), 10);
                  const dispatcher = reduxManagedPlaceholders[res.placeholder].dispatcher;
                  if (!Number.isNaN(val) && typeof dispatcher === 'function') {
                    window.appState.dispatch(dispatcher(val));
                  }
                // If the placeholder is ID, insert content as HTML
                } else if (res.placeholder.indexOf('#') === 0) {
                  if (res.response.replace) {
                    $(res.placeholder).replaceWith(res.response.content);
                  } else {
                    $(res.placeholder).html(res.response.content);
                  }
                // If the placeholder is class, insert content as value of the element
                } else if (res.placeholder) {
                  $(res.placeholder).val(res.response.content);
                }
              }
            });
            if (o.callback) {
              o.callback(resp);
            }
          }
        },
        error: function(resp) {
          if (o.error) {
            o.error(resp);
            return true;
          }
          return false;
        }
      });
    }
    loadBlock(arr);
  };
  
}(jQuery));
